import React, { Component } from 'react';
import { Orient } from '@src/slide/application/service/snap-line-service/interface/orient.interface';
import { DotLine } from '@src/slide/application/service/snap-line-service/render/components/extend-line/dot-line';
import type { IActiveSnapGridLine } from '@src/slide/application/service/snap-line-service/interface/line.interface';
import type { IRefElement } from '@src/slide/application/service/snap-line-service/interface/ref.interface';
import type { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';
import { IBaseUIProps } from '@src/slide/application/service/snap-line-service/interface/render.interface';

export interface EdgeSnapLineProps extends IBaseUIProps {
    snapLines: IActiveSnapGridLine[];
    color?: string
    displayPadding: number;
}

/**
 * 边缘（基线也复用此组件）参考线
 * 在边缘/基线对齐的时候，在对其的边上渲染相应的参考线
 */
export class EdgeSnapLines extends Component<EdgeSnapLineProps> {
    public render() {
        return <>
            {
                this.props.snapLines.map(((snapLine, index) => {
                    const { orient, refElements } = snapLine;
                    // ref 只会有一个
                    const [ref] = refElements;
                    if (!ref) return <></>;

                    return <DotLine
                        key={index}
                        classnames={{ 'edge-snap-line': true }}
                        rect={this.getLineRect(ref, snapLine)}
                        orient={orient}
                        color={this.props.color}
                        scale={this.props.scale}
                        strokeDash={this.props.strokeDash}
                    />;
                }))
            }
        </>;
    }

    private get displayPadding() {
        return this.props.displayPadding;
    }

    private get strokeWidth() {
        return this.props.strokeWidth;
    }

    private getLineRect(ref: IRefElement, snapLine: IActiveSnapGridLine): IRect {
        const { position, frame } = snapLine;
        const refFrame = ref.outerFrameOnSlide;

        if (this.isHorizontal(snapLine)) {
            const leftEdge = Math.min(refFrame.left, frame.left) - this.displayPadding;
            const rightEdge = Math.max(refFrame.left + refFrame.width, frame.left + frame.width) + this.displayPadding;
            const displayLength = rightEdge - leftEdge;

            return {
                width: displayLength,
                height: this.strokeWidth,
                left: leftEdge,
                top: position,
            };
        }

        const topEdge = Math.min(refFrame.top, frame.top) - this.displayPadding;
        const bottomEdge = Math.max(refFrame.top + refFrame.height, frame.top + frame.height) + this.displayPadding;
        const displayLength = bottomEdge - topEdge;

        return {
            width: this.strokeWidth,
            height: displayLength,
            left: position,
            top: topEdge,
        };
    }

    private isHorizontal(snapLine: IActiveSnapGridLine) {
        return snapLine.orient === Orient.HORIZONTAL;
    }
}
